import { reactQueryPatch } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

export interface ModerationActionOptions {
  disableConnections?: boolean;
  disableDirectMessaging?: boolean;
  flagForChat?: boolean;
  flagForConnect?: boolean;
  flagMember?: boolean;
}

export const useModerationApi = () => {
  const approve = (id: string, options: ModerationActionOptions = {}) =>
    reactQueryPatch<unknown, object>(
      internalApi.flaggedContent.approve({ id }),
      {
        flag_member: options.flagMember,
        flag_for_connect: options.flagForConnect,
      },
    );

  const reject = (
    id: string,
    reason: string | null,
    options: ModerationActionOptions = {},
  ) =>
    reactQueryPatch<unknown, object>(
      internalApi.flaggedContent.reject({ id }),
      {
        action_reason_body: reason,
        flag_member: options.flagMember,
        flag_for_connect: options.flagForConnect,
        flag_for_chat: options.flagForChat,
        disable_direct_messaging: options.disableDirectMessaging,
        disable_connections: options.disableConnections,
      },
    );

  return {
    approve,
    reject,
  };
};
